<p-dialog [draggable]="false" [resizable]="false" [(visible)]="cookiePopupVisibility" [style]="{ width: '450px', height: '61%%' }" position="bottomleft" [closable]="false">
    <div class="text-center fm-prompt" style="padding: 10px 10px 0px 10px;">
        <div class=" fw-bold text-black fs-4 mb-2">
            We value your privacy
        </div>
        <div class="fm-rubik mb-4" style="font-size: 0.9rem;font-weight: 400;">
            We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
        </div>
        <div class="mt-1 p-2 mb-0 row" style="text-align: center;">
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'" class="mb-3">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="acceptCookie()">Accept All
                </button>
            </div>
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'" class="mb-3">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="customizeCookie()">Customize
                </button>
            </div>
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #b4b4bb;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="rejectCookie()">Reject All
                </button>
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog [draggable]="false" [resizable]="false" [(visible)]="customCookiePopupVisibility" [style]="{ width: '650px', height: '61%%' }" [closable]="true">
    <div class="text-center fm-prompt" style="padding: 0px 10px 0px 10px;">
        <div class=" fw-bold text-black fs-4 mb-2">
            Customize Consent Preferences
        </div>
        <div class="fm-rubik mb-4" style="font-size: 0.9rem;text-align: left;">
            We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below.
            The cookies that are categorized as "Necessary" are stored on your browser as they are essential for enabling the basic functionalities of the site.
            We also use third-party cookies that help us analyze how you use this website, store your preferences, and provide the content and advertisements that are relevant to you. These cookies will only be stored in your browser with your prior consent.
            You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience.
        </div>
        <div style="display: flex; flex-direction: column;">
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Necessary</span>
                    <span style="font-size: 14px; font-weight: 600; color: #008000;">Always Active</span>
                </div>
                <div style="text-align: left;">
                    Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.
                </div>
            </div>
            <p-divider></p-divider>
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Functional</span>
                    <p-inputSwitch ></p-inputSwitch>
                </div>
                <div style="text-align: left;">
                    Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.
                </div>
            </div>
            <p-divider></p-divider>
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Analytics</span>
                </div>
                <div style="text-align: left;">
                    Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.                </div>
                </div>
            <p-divider></p-divider>
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Performance</span>
                    <p-inputSwitch ></p-inputSwitch>
                </div>
                <div style="text-align: left;">
                    Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors.
                </div>
            </div>
            <p-divider></p-divider>
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Advertisement</span>
                </div>
                <div style="text-align: left;">
                    Advertisement cookies are used to provide visitors with customized advertisements based on the pages you visited previously and to analyze the effectiveness of the ad campaigns.
                </div>
            </div>
            <p-divider></p-divider>
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; justify-content: space-between;">
                    <span style="font-size: 16px; font-weight: 600;">Uncategorized</span>
                    <p-inputSwitch ></p-inputSwitch>
                </div>
                <div style="text-align: left;">
                    Other uncategorized cookies are those that are being analyzed and have not been classified into a category as yet.
                </div>
            </div>
            <!--p-accordion class="web-left">
                <p-accordionTab>
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center">
                            <i class="pi pi-calendar mr-2"></i>
                            <span class="vertical-align-middle">Header I</span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                        Certainly! Our kitchen strictly adheres to using only halal ingredients, ensuring there are no non-halal ingredients present in our facilities.
                    </ng-template>
                </p-accordionTab>
            </p-accordion-->
        </div>
        <p-divider></p-divider>
        <div class="mt-1 p-2 mb-0 row" style="text-align: center;">
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'" class="mb-3">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="rejectCookieOpen()">Reject All
                </button>
            </div>
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'" class="mb-3">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="customizeCookieOpen()">Save My Preferences
                </button>
            </div>
            <div [class]="!isMobile ? 'col-md-4' : 'col-md-12'">
                <button
                    class="btn w-100 fm-prompt fw-bold" style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                    (click)="acceptCookieOpen()">Accept All
                </button>
            </div>
        </div>
    </div>
</p-dialog>
<p-avatar icon="pi pi-check-circle" styleClass="mr-2 cookie-avatar" size="xlarge" [style]="{ 'background-color': '#EF870A', color: 'white', cursor: 'pointer' }" shape="circle" *ngIf="!cookiePopupVisibility && !customCookiePopupVisibility" (click)="cookiePopupVisibility = !cookiePopupVisibility"/>